import smartSolveApi from './instances/smartsolve';

export const submitQueueProcessRecord = async (entityName, actionName, ids) => {
  try {
    const response = await smartSolveApi.post('/performqueueaction', {
      ids,
      actionName,
      entityName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`submitQueueProcessRecord() failed: ${e}`);
  }
};
